<template>
  <div class="pr-2">
    <v-row>
      <v-col cols="6">
        <highcharts :options="chartOptionsBar" ref="lineCharts"></highcharts>
      </v-col>
      <v-col cols="6">
        <highcharts :options="chartOptions" ref="lineCharts"></highcharts>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="11" class="ml-12">
        <v-tabs
          v-model="filters.month_value_for_tab"
          style="background-color: transparent!important;max-width:100%!important;"
        >
          <v-tab
            v-for="item in itemEncabezados"
            :key="item.value"
            style="width:100%;background: rgb(182 182 182);color: black;margin-left:1px;margin-right:1px;margin-top:1%;margin-bootom:1%;border: 1px solid #717171;border-radius: 3px;"
            elevation="2"
            @click="handleChangeMonth(item.value)"
          >
            {{ item.titulo }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

import DashboardApi from "../../../apis/Dashboard";
import Tools from "../../../helpers/Tools";
import { generateColor } from "../../../helpers/GenerateColor/generateColor";

export default {
  name: "ProductionDoctorMonthChart",
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataReportProduction: [],
      dataReportAmount: [],
      categories: [],
      dataValues: [],
      list_years: [],
      itemEncabezados: [
        { titulo: "ENERO", value: "01" },
        { titulo: "FEBRERO", value: "02" },
        { titulo: "MARZO", value: "03" },
        { titulo: "ABRIL", value: "04" },
        { titulo: "MAYO", value: "05" },
        { titulo: "JUNIO", value: "06" },
        { titulo: "JULIO", value: "07" },
        { titulo: "AGOSTO", value: "08" },
        { titulo: "SEPTIEMBRE", value: "09" },
        { titulo: "OCTUBRE", value: "10" },
        { titulo: "NOVIEMBRE", value: "11" },
        { titulo: "DICIEMBRE", value: "12" },
      ],
      list_type: [
        { id: "year", name: "Anual" },
        { id: "biannual", name: "Semestre" },
        { id: "month", name: "Mensual" },
        { id: "week", name: "Semanal" },
        { id: "diary", name: "Diarias" },
      ],
      list_semestre: [
        { id: "Semestre 1 - ", name: "Semestre 1" },
        { id: "Semestre 2 - ", name: "Semestre 2" },
      ],
      list_week: [
        { id: "Semana 1", name: "Semana 1" },
        { id: "Semana 2", name: "Semana 2" },
        { id: "Semana 3", name: "Semana 3" },
        { id: "Semana 4", name: "Semana 4" },
        { id: "Semana 5", name: "Semana 5" },
      ],
      list_diary: [
        { id: "Lunes", name: "Lunes" },
        { id: "Martes", name: "Martes" },
        { id: "Miercoles", name: "Miercoles" },
        { id: "Jueves", name: "Jueves" },
        { id: "Viernes", name: "Viernes" },
        { id: "Sabado", name: "Sabado" },
        { id: "Domingo", name: "Domingo" },
      ],
      list_months: [],
      filters: {
        year_value: this.$moment().year(),
        month_value: this.$moment().month() + 1,
        month_value_for_tab: this.$moment().month(),
        type_value: "month",
        semestre_value: "Semestre 1 - ",
        week_value: "Semana 1",
        diary_value: "Lunes",
      },
      chartOptions: {
        chart: {
          type: "area",
        },
        title: {
          text: "Ventas por mes",
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>S/ {point.y:.1f}</b>",
        },
        yAxis: {
          min: 0,
          title: {
            text: "Monto (S/)",
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        credits: {
          enabled: false,
        },
        series: [],
      },
      chartOptionsBar: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: "Cantidad de Análisis Referenciados por mes",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y:.1f}</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.y:.1f}",
            },
          },
        },
        series: [
          {
            name: "",
            colorByPoint: true,
            data: [
              // {
              //   name: "Chrome",
              //   y: 70.67,
              //   sliced: true,
              //   selected: true,
              // },
            ],
          },
        ],
      },
    };
  },
  methods: {
    customText(item) {
      let text = item.name;

      return text;
    },
    getProductionByDoctor() {
      DashboardApi.getProductionByDoctor({
        year_value: this.filters.year_value,
        month_value: this.filters.month_value,
        type_value: "month",
      })
        .then((response) => {
          this.dataReportProduction = response.data;
          this.prepareData();
        })
        .catch((error) => {
          console.log("Ocurrió un error");
        });
    },
    getAmountByDoctor() {
      DashboardApi.getAmountByDoctor({
        year_value: this.filters.year_value,
        month_value: this.filters.month_value,
        type_value: "month",
      })
        .then((response) => {
          this.dataReportAmount = response.data;
          this.prepareDataAmount();
        })
        .catch((error) => {
          console.log("Ocurrió un error");
        });
    },
    prepareData() {
      let analisys = [];
      let values = [];

      this.dataReportProduction.forEach((element, index) => {
        if (this.filters.type_value == "month") {
          if (element.name == this.getMonthName(this.filters.month_value)) {
            analisys = [];
            values = [];
            element.value.map((dt, i) => {
              analisys.push(dt.fullname);
              let itemValue = {
                color: generateColor(),
                y: parseFloat(dt.sale_total),
              };
              values.push(itemValue);
            });
          }
        }
      });

      let valueSeries = [];
      valueSeries.push({
        name: "",
        data: values,
      });
      this.chartOptions.xAxis.categories = analisys;
      this.chartOptions.series = valueSeries;
    },
    prepareDataAmount() {
      let value_bar = [];
      this.dataReportAmount.forEach((element, index) => {
        value_bar.push({
          name: element.name,
          color: generateColor(),
          y: Number(element.value),
        });
      });
      console.log(value_bar);
      this.chartOptionsBar.series[0].data = value_bar;
    },
    getMonthName(number_month) {
      let names = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      return names[number_month - 1];
    },
    generateListYears() {
      this.list_years = [];
      let start_year = 2022;
      let end_year = this.$moment().year();
      for (let i = start_year; i <= end_year; i++) {
        this.list_years.push(i);
      }
    },
    handleUpdateChart() {
      this.handleChangeTitle();
      this.getProductionByDoctor();
      this.getAmountByDoctor();
    },
    handleChangeTitle() {
      if (this.filters.type_value == "year") {
        this.chartOptions.title.text =
          "Producción de Análisis Referencidos del " + this.filters.year_value;
      } else if (this.filters.type_value == "biannual") {
        this.chartOptions.title.text = `Producción de Análisis Referencidos del ${this.filters.semestre_value} ${this.filters.year_value} `;
      } else if (this.filters.type_value == "month") {
        this.chartOptions.title.text = `Producción de Análisis Referencidos del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)}`;
      } else if (this.filters.type_value == "week") {
        this.chartOptions.title.text = `Producción de Análisis Referencidos del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)} - ${
          this.filters.week_value
        }`;
      } else if (this.filters.type_value == "diary") {
        this.chartOptions.title.text = `Producción de Análisis Referencidos - ${this.filters.diary_value}`;
      }
    },
    loadData() {
      this.list_months = Tools.getMonths();
      this.generateListYears();
      this.handleChangeTitle();
      this.getProductionByDoctor();
      this.getAmountByDoctor();
    },
    async handleChangeMonth(item) {
      this.filters.month_value = Number(item);
      this.filters.month_value_for_tab = Number(item);
      this.prepareData();
      // this.prepareDataAmount();
      this.handleChangeTitle();
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped></style>
